module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-d105dbfc29cdb9401821a8f785c93569.png";